import { FaroTextField } from "@components/common/faro-text-field/faro-text-field";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { assert } from "@faro-lotv/foundation";
import { Box } from "@mui-wrapper";
import { useAccountSettingsLayout } from "@pages/account-settings/account-settings-layout/account-settings-layout-utils";
import { useUserContext } from "@pages/account-settings/user-provider";
import { useAppDispatch } from "@store/store-helper";
import { updateCurrentUserProfile } from "@store/user/user-slice-thunk";
import { UserProfile } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useCallback } from "react";
/** Change the account name */
export function AccountChangeName({
  field
}) {
  const {
    user
  } = useUserContext();
  assert(user, "User has to be defined to change name");
  const {
    accountSettingsFontSize
  } = useAccountSettingsLayout();
  const {
    trackEvent
  } = useTrackEvent();
  const dispatch = useAppDispatch();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const currentFieldValue = field === "firstName" ? user.firstName : user.lastName ?? "";
  const onChangeDisplayName = useCallback(async value => {
    const trimmedValue = value.trim();
    trackEvent({
      name: UserProfile.updateProfile,
      props: {
        attribute: {
          field
        }
      }
    });
    try {
      await dispatch(updateCurrentUserProfile(field === "firstName" ? {
        firstName: trimmedValue
      } : {
        lastName: trimmedValue
      })).unwrap();
      return trimmedValue;
    } catch (error) {
      handleErrorWithToast({
        id: `changeDisplayName-${Date.now().toString()}`,
        title: `Could not change ${field}`,
        error
      });
      return currentFieldValue;
    }
  }, [currentFieldValue, dispatch, field, handleErrorWithToast, trackEvent]);
  return <Box component="div" sx={{
    width: "100%"
  }}>
      <FaroTextField initialValue={currentFieldValue} onConfirmed={onChangeDisplayName} isFullWidth={true} faroVariant="row" isReadOnly={false} minInputLength={1} fontSize={accountSettingsFontSize} />
    </Box>;
}